<template>
  <div>
    <div class="d-flex mb-2">
      <h3 class="h6 font-weight-bold m-0 flex-fill">1. niveau</h3>
      <transition name="fade">
        <b-btn
          variant="link"
          v-show="keyword1 !== null"
          @click="resetKeywords(true, true, true, true)"
          size="sm"
          class="p-0 text-secondary"
        >
          <b-icon icon="x-circle-fill"></b-icon>
          <span class="hidden-text">Fjern 1. niveau</span>
        </b-btn>
      </transition>
    </div>
    <b-button-group vertical class="w-100">
      <transition-group name="fold">
        <b-button
          v-for="(keyword, index) of computedKeywords"
          :key="keyword.key"
          :variant="keyword1 && keyword.key === keyword1.key ? 'primary' : 'light'"
          @click="keyword1 = {key: keyword.key, value: keyword.value, id: keyword.id}"
          :class="keyword1 !== null ? {active: keyword.key === keyword1.key, 'border-top': index > 0} : {'border-top': index > 0}"
          class="w-100 px-3 py-2 text-left"
        >
          <div class="d-flex justify-content-between">
            <span>{{keyword.value | labelize}}</span>
            <b-icon icon="check" v-if="keyword1 && keyword.value === keyword1.value"></b-icon>
          </div>
        </b-button>
      </transition-group>
    </b-button-group>
    <transition name="fade">
      <div v-show="keyword1 !== null" class="mt-4">
        <div class="d-flex mb-2">
          <h3 class="h6 font-weight-bold m-0 flex-fill">2. niveau</h3>
          <transition name="fade">
            <b-btn
              variant="link"
              v-show="keyword2 !== null"
              @click="resetKeywords(false, true, true, true)"
              size="sm"
              class="p-0 text-secondary"
            >
              <b-icon icon="x-circle-fill"></b-icon>
              <span class="hidden-text">Fjern 2. niveau</span>
            </b-btn>
          </transition>
        </div>
        <b-button-group vertical class="w-100">
          <transition-group name="fold">
            <b-button
              v-for="(keyword, index) of secondKeywordOptions"
              :key="keyword.key"
              :variant="keyword2 && keyword.key === keyword2.key ? 'primary' : 'light'"
              @click="keyword2 = {key: keyword.key, value: keyword.value, id: keyword.id}"
              :class="keyword2 !== null ? {active: keyword.key === keyword2.key, 'border-top': index > 0} : {'border-top': index > 0}"
              class="w-100 px-3 py-2 text-left"
            >
              <div class="d-flex justify-content-between">
                <span>{{keyword.value | labelize}}</span>
                <b-icon icon="check" v-if="keyword2 && keyword.value === keyword2.value"></b-icon>
              </div>
            </b-button>
          </transition-group>
        </b-button-group>
      </div>
    </transition>

    <transition name="fade">
      <div v-show="thirdKeywordOptions.length" class="mt-4">
        <div class="d-flex mb-2">
          <h3 class="h6 font-weight-bold m-0 flex-fill">3. niveau</h3>
          <transition name="fade">
            <b-btn
              variant="link"
              v-show="keyword3 !== null"
              @click="resetKeywords(false, false, true, true)"
              size="sm"
              class="p-0 text-secondary"
            >
              <b-icon icon="x-circle-fill"></b-icon>
              <span class="hidden-text">Fjern 3. niveau</span>
            </b-btn>
          </transition>
        </div>
        <b-button-group vertical class="w-100">
          <transition-group name="fold">
            <b-button
              v-for="(keyword, index) of thirdKeywordOptions"
              :key="keyword.key"
              :variant="keyword3 && keyword.key === keyword3.key ? 'primary' : 'light'"
              @click="keyword3 = {key: keyword.key, value: keyword.value, id: keyword.id}"
              :class="keyword3 !== null ? {active: keyword.key === keyword3.key, 'border-top': index > 0} : {'border-top': index > 0}"
              class="w-100 px-3 py-2 text-left"
            >
              <div class="d-flex justify-content-between">
                <span>{{keyword.value | labelize}}</span>
                <b-icon icon="check" v-if="keyword3 && keyword.value === keyword3.value"></b-icon>
              </div>
            </b-button>
          </transition-group>
        </b-button-group>
      </div>
    </transition>

    <transition name="fade">
      <div v-show="fourthKeywordOptions.length" class="mt-4">
        <div class="d-flex mb-2">
          <h3 class="h6 font-weight-bold m-0 flex-fill">4. niveau</h3>
          <transition name="fade">
            <b-btn
              variant="link"
              v-show="keyword4 !== null"
              @click="resetKeywords(false, false, false, true)"
              size="sm"
              class="p-0 text-secondary"
            >
              <b-icon icon="x-circle-fill"></b-icon>
              <span class="hidden-text">Fjern 4. niveau</span>
            </b-btn>
          </transition>
        </div>
        <b-button-group vertical class="w-100">
          <transition-group name="fold">
            <b-button
              v-for="(keyword, index) of fourthKeywordOptions"
              :key="keyword.key"
              :variant="keyword4 && keyword.key === keyword4.key ? 'primary' : 'light'"
              @click="keyword4 = {key: keyword.key, value: keyword.value, id: keyword.id}"
              :class="keyword4 !== null ? {active: keyword.key === keyword4.key, 'border-top': index > 0} : {'border-top': index > 0}"
              class="w-100 px-3 py-2 text-left"
            >
              <div class="d-flex justify-content-between">
                <span>{{keyword.value | labelize}}</span>
                <b-icon icon="check" v-if="keyword4 && keyword.value === keyword4.value"></b-icon>
              </div>
            </b-button>
          </transition-group>
        </b-button-group>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    keywords: {
      type: Object,
      default: function () { return {
        level_1: null,
        level_2: null,
        level_3: null,
        level_4: null,
      } }
    }
  },
  data: () => ( {
    keyword1: null,
    keyword2: null,
    keyword3: null,
    keyword4: null,
    taxonomy: []
  }),
  mounted() {
    if (this.keywords.level_1) this.keyword1 = this.keywords.level_1
    if (this.keywords.level_2) this.keyword2 = this.keywords.level_2
    if (this.keywords.level_3) this.keyword3 = this.keywords.level_3
    if (this.keywords.level_4) this.keyword4 = this.keywords.level_4
    this.axios.get('/api/taxonomy').then((response) => {
      this.taxonomy = response.data
    })
  },
  watch: {
    keywords: function () {
      this.keyword1 = this.keywords.level_1
      this.keyword2 = this.keywords.level_2
      this.keyword3 = this.keywords.level_3
      this.keyword4 = this.keywords.level_4
    },
    keyword1: function () {
      this.$emit('keywordOneChange', this.keyword1)
    },
    keyword2: function () {
      this.$emit('keywordTwoChange', this.keyword2)
    },
    keyword3: function () {
      this.$emit('keywordThreeChange', this.keyword3)
    },
    keyword4: function () {
      this.$emit('keywordFourChange', this.keyword4)
    },
    allselectedKeywords: function () {
      this.$emit('keywordsChange', this.allselectedKeywords)
    }
  },
  computed: {
    computedKeywords () {
      let keywords = []
      if (this.taxonomy && this.taxonomy.length) {
        for (let keyword of this.taxonomy) {
          if (this.keyword1 !== null && keyword.key === this.keyword1.key) {
            keywords.push(keyword)
          } else if (this.keyword1 === null) {
            keywords.push(keyword)
          }
        }
      }
      return keywords.sort((a, b) => a.value > b.value && 1 || -1)
    },
    secondKeywordOptions () {
      let options = []
      if (this.keyword1 && this.keyword1 !== null) {
        let children = this.computedKeywords.filter(keyword => keyword.key === this.keyword1.key)
        if (children[0] && children[0].children) {
          for (let keyword of children[0].children) {
            if (this.keyword2 !== null && keyword.key === this.keyword2.key) {
              options.push(keyword)
            } else if (this.keyword2 === null) {
              options.push(keyword)
            }
          }
        }
      }
      return options.sort((a, b) => a.value > b.value && 1 || -1)
    },
    thirdKeywordOptions () {
      let options = []
      if (this.keyword2 && this.keyword2 !== null) {
        let children = this.secondKeywordOptions.filter(label => label.key === this.keyword2.key)
        if (children[0] && children[0].children) {
          for (let keyword of children[0].children) {
            if (this.keyword3 !== null && keyword.key === this.keyword3.key) {
              options.push(keyword)
            } else if (this.keyword3 === null) {
              options.push(keyword)
            }
          }
        }
      }
      return options.sort((a, b) => a.value > b.value && 1 || -1)
    },
    fourthKeywordOptions () {
      let options = []
      if (this.keyword3 && this.keyword3 !== null) {
        let children = this.thirdKeywordOptions.filter(label => label.key === this.keyword3.key)
        if (children[0] && children[0].children) {
          for (let keyword of children[0].children) {
            if (this.keyword4 !== null && keyword.key === this.keyword4.key) {
              options.push(keyword)
            } else if (this.keyword4 === null) {
              options.push(keyword)
            }
          }
        }
      }
      return options.sort((a, b) => a.value > b.value && 1 || -1)
    },
    allselectedKeywords () {
      let keywords = {
        level_1: this.keyword1,
        level_2: this.keyword2,
        level_3: this.keyword3,
        level_4: this.keyword4
      }
      return keywords
    }
  },
  methods: {
    resetKeywords(key1 = false, key2 = false, key3 = false, key4 = false) {
      if (key1) {
        this.keyword1 = null
      }
      if (key2) {
        this.keyword2 = null
      }
      if (key3) {
        this.keyword3 = null
      }
      if (key4) {
        this.keyword4 = null
      }
    },
  }
}
</script>

<style>

</style>